import { IApiError } from '@/models/apiError.model';
import { IPagination } from '@/models/pagination.model';
import { IPartnerProfile } from '@/models/partners.model';
import { TGetPartnerQuery } from '../helpers/types';

export const PARTNERS_LIST_SLICE_NAME = 'partnersList';

export interface PartnersListState {
  partnersList: {
    data: IPartnerProfile[];
    meta: IPagination;
  } | null;
  partnerDetails: IPartnerProfile | null;
  isLoading: boolean;
  error: IApiError | null;
  query: TGetPartnerQuery | null;
}

export const initialState: PartnersListState = {
  partnerDetails: null,
  partnersList: null,
  isLoading: false,
  query: null,
  error: null,
};
